import React from "react"

const KlassappTableContext = React.createContext({isShowScrollTable: true, setIsShowScrollTable: null})

export {KlassappTableContext}
